module.exports = __webpack_public_path__ + "static/media/brand-refresh-clear-dark-icon.88a423a6.svg";